import createClient from 'openapi-fetch';
import type { paths } from './broker.openapi';
import { createOpenApiAdapter } from '../../shared/infra/fetch-open-api-adapter';

const brokerFetchClient = createClient<paths>({
	baseUrl: `${process.env.REACT_APP_AUTH0_AUDIENCE}/service/broker`,
});

export const brokerFetchClientAdapter = createOpenApiAdapter<paths>(brokerFetchClient);
